import FloatingLabelTextInput from './FloatingLabelTextInput';

export default FloatingLabelTextInput;
